import { render, staticRenderFns } from "./AddImprovement.vue?vue&type=template&id=130423a5&lang=pug&"
import script from "./AddImprovement.vue?vue&type=script&lang=js&"
export * from "./AddImprovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports